import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqosphereLottery {
  constructor(api) {
    this.api = api
  }

  confirm = async prizeId => {
    const res = await this.api.post(
      '/packcode/prizelotteryexchange/confirm?rpc=true',
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('confirmLottery'),
        data: {
          prizeId
        }
      }
    )
    return res
  }

  confirmPackcodeQoins = async data => {
    const res = await this.api.post('/packcode/qoins/confirm', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('confirmLottery'),
      data
    })
    return res
  }

  getExchangeStock = async prizeId => {
    const res = await this.api.get(
      '/packcode/prizelotteryexchange/stockexchange?rpc=true&prizeId=' +
        prizeId,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('getExchangeStock')
      }
    )
    return res
  }

  confirmAddress = async data => {
    const res = await this.api.post(
      '/packcode/prizelotteryexchange/confirmaddress',
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('confirmAddress'),
        data
      }
    )
    return res
  }
}
